import { Component, effect, Inject, OnInit, Renderer2, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from './components';
import { headerComponent } from './components';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SharedService } from './core/shared/shared.service';
import { environment } from 'src/environments/environment';
import { PropertyService } from './components/properties/service/property.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, headerComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLoginScreen = true;
  isChatbotScreen = false;
  isSidebarToggled = false;

  isDomainValid = true; // 👈 new flag
  checkingDomain = true; // 👈 for loader or blocking UI while verifying
  currentDomain = window.location.hostname
  fullUrl = window.location.href;
  // Widget related
  widgetUrl = '';
  widgetMode = environment?.widgetMode || 'production';
  propertyId = signal<string | null>(null);

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private renderer: Renderer2,
    private propertyService: PropertyService,
    @Inject(DOCUMENT) private document: Document
  ) {
    effect(() => {
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(async (event: NavigationEnd) => {
          this.isLoginScreen =
            window.location.href.includes('404') ||
            window.location.href.includes('login') ||
            window.location.href.includes('forgot-password') ||
            window.location.href.includes('tour-verify') ||
            window.location.href.includes('manage-tours') ||
            window.location.href.includes('schedule/tour') ||
            window.location.href.includes('gallery');

          this.isChatbotScreen = window.location.href.includes('chatbot');

          if (this.isChatbotScreen) {
            const getUserData = await this.propertyService.getUserInfo().toPromise();
            this.propertyId.set(getUserData.property_id);
            this.loadChatbotWidget();
          } else {
            // 👇 REMOVE widget when leaving chatbot
            const script = this.document.getElementById('leasing-widget-script');
            const holder = this.document.getElementsByClassName('leasing-widget-holder');
            if (script) {
              script.remove();
            }
            if (holder && holder.length > 0) {
              holder[0].remove();
            }
          }

        });
    });
  }
  toggleSidebar() {
    this.isSidebarToggled = !this.isSidebarToggled;
  }

  ngOnInit() {
    //Need to bypass for super admin domain
    // this.currentDomain = 'admin.petrieai.com';
    console.log('Current Domain:', this.currentDomain);

    if ((this.currentDomain == environment.superAdminDomain) || environment.impersonateAsSuperAdmin) {
      console.log("Full URL   ", this.fullUrl)
      this.sharedService.loadCurrentUser().subscribe();
      console.log('Super Admin Domain - Bypassing domain verification.');
      this.checkingDomain = false;
    } else {
      // Call the service to check if the domain exists
      this.sharedService.verifyDomain(this.currentDomain).subscribe({
        next: (res) => {
          this.isDomainValid = res.exists;
          this.checkingDomain = false;
          if (!res.exists) {
            // redirect to 404 page
            this.router.navigate(['/404']);
          } else {
            this.sharedService.loadCurrentUser().subscribe();
          }
        },
        error: (err) => {
          console.error('Domain check failed:', err);
          this.router.navigate(['/404']);
        },
      });
    }
  }


  private loadChatbotWidget() {
    // Prevent duplicate script injection
    if (this.document.getElementById('leasing-widget-script')) {
      return;
    }
    const script = this.renderer.createElement('script');
    script.id = 'leasing-widget-script';
    script.src = `${window.location.origin}/js/leasing-widget.js`;
    script.defer = true;
    script.setAttribute('data-property-id', this.propertyId() ?? '');
    script.setAttribute('data-mode', this.widgetMode);
    this.renderer.appendChild(this.document.body, script);
  }
}
